import { render } from "./Temavezeto.vue?vue&type=template&id=857b1ef6"
import script from "./Temavezeto.vue?vue&type=script&lang=js"
export * from "./Temavezeto.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__